<template>
    <nav class="navigation container container--full container--nooverflow" @mouseleave="languageSwitcher = false">
        <div class="navigation__left">
            <div @click="goBack" class="navigation__back" v-if="showBack">
                <Icon :name="'arrow-left'"></Icon>
            </div>
            <a href="https://go.puma.com/koswb" target="_blank" class="navigation__pumacom" @click.prevent="outboundLinkClicked('https://go.puma.com/koswb')" v-translate>{{ christmasCalendar || christmasOverview === 'christmas' ? 'puma_com_christmas' : 'visit_puma_com' }} </a>
        </div>
        <!-- <div class="navigation__main">
            <router-link :to="{ name: 'Discover'}" class="navigation__main__link">
                Discover
            </router-link>
            <router-link :to="{ name: 'Profile'}" class="navigation__main__link">
                Stats
            </router-link>
        </div> -->
        <div class="navigation__logo">
            <router-link :to="{ name: 'Discover'}">
                <img alt="PUMATRAC" src="../assets/trac-logo-light.svg" />
            </router-link>
        </div>
        <div class="navigation__right">
            <div class="navigation__right__item" v-if="user">
                <div class="navigation__right__link navigation__right__link--search" :class="[{'active' : searchVisible}, {'filled' : searchValue !== ''}]">
                    <div class="navigation__search">
                        <input  type="text" 
                                class="navigation__search__input"
                                :class="{'visible' : searchVisible}"
                                ref="searchInput" 
                                :placeholder="this.$gettext('search')" 
                                @input="search"
                                @keypress.enter="search"
                                v-model="searchValue">
                        <div class="navigation__search__icon search" @click.prevent="toggleSearch">
                            <Icon name="search"></Icon>
                        </div>
                        <div class="navigation__search__icon close" @click.prevent="clearSearch">
                            <Icon name="close"></Icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="navigation__right__item language-switcher" v-if="christmasCalendar" :class="{'language-switcher--hover' : languageSwitcher && !isMobileNav}">
                <div @mouseover="languageSwitcher = true" class="navigation__right__item__language">
                    <span class="navigation__right__item__text">{{ $language.current }}</span>
                    <Icon name="arrow-down" :width="12" :height="12" :viewbox="'0 0 12 8'"></Icon>
                </div>
                <div class="navigation__right__item__body" v-show="languageSwitcher && !isMobileNav">
                    <div @click="switchLanguage(index)" :class="{ 'active' :$language.current === index }" class="navigation__right__item__body__text" v-for="(lang, index) in $language.available" :key="index">{{index}} <span>{{ lang }}</span></div>
                </div>
            </div>
            
            <div class="navigation__right__item" v-if="user">
                <router-link :to="{name: 'Workouts', params: {filter: 'favourites'}}" class="navigation__right__link">
                    <Icon name="heart-outline"></Icon>
                </router-link>
            </div>

            <div class="navigation__right__item profile-nav" v-if="user" @mouseleave="toggleDropdown(false)">
                <!-- <div @click.capture="toggleProfileNav"> -->
                    <router-link :to="{name: 'Profile'}" class="navigation__right__link" :class="{'active' : dropdownVisible}">
                        <div @mouseenter="toggleDropdown(true)">
                            <Icon name="profile"></Icon>
                        </div>
                    </router-link>
                <!-- </div> -->

                <!-- <div class="navigation__dropdown" :class="{'visible' : dropdownVisible}">
                    <div class="navigation__dropdown__top">
                        <router-link :to="{name: 'Profile'}" class="navigation__dropdown__link">
                            My Profile
                        </router-link>
                    </div>
                    <div class="navigation__dropdown__bottom">
                        <a @click="logout" class="navigation__dropdown__link h6">Log out</a>
                    </div>
                </div> -->
            </div>

            <div class="navigation__right__item" v-if="user" @click="filterClicked">
                <router-link :to="{name: 'Workouts', query: {mode:  'filters'}}" class="navigation__right__link navigation__right__link--mobile">
                    <Icon name="filter"></Icon>
                </router-link>

                <puma-button :linkObject="{name: 'Workouts', query: {mode:  'filters'}}" icon="filter" type="grey" class="navigation__right__filter"><translate>filter</translate></puma-button>
            </div>

            <!-- <div class="navigation__right__item" v-if="user">
                <a @click="logout" class="navigation__right__link" v-if="user">
                    <Icon name="logoff"></Icon>
                </a>
            </div> -->

            <puma-button :link="'/login'" icon="profile" type="grey" class="navigation__right__login" v-if="!user && !hideLogin"><translate>login</translate></puma-button>
        </div>
        <div class="language-switcher-mobile" v-show="isMobileNav && languageSwitcher">
            <div @click="switchLanguage(index)" :class="{ 'active' :$language.current === index }" class="language-switcher-mobile__text" v-for="(lang, index) in $language.available" :key="index">{{index}} <span>{{ lang }}</span></div>
        </div>
    </nav>
</template>

<script>
import router from "../router";
import { mapGetters } from "vuex"
import { clearUser } from '../utils/authentication';
import { captureOutboundLink } from '../utils/tracking';

export default {
    props: {
        showBack: {
            type: Boolean,
            default: false
        },
        hideLogin: {
            type: Boolean,
            default: false
        },
        christmasCalendar: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            dropdownVisible: false,
            searchVisible: false,
            searchValue: '',
            christmasOverview: this.$route.params.christmasOverview,
            languageSwitcher: false,
        }
    },
    computed: {
        ...mapGetters(['user', 'isMobileNav']),
        filterLinkObject() {
            if(this.$route.query.mode === undefined || this.$route.query.mode !== 'filters') {
                return {name: 'Workouts', query: {mode:  'filters'}};
            } else {
                return null
            }
        }
    },
    mounted() {
        this.addEventListeners()
    },
    beforeDestroy() {
        this.removeEventListeners()
    },
    methods: {
        switchLanguage(lang) {
            this.$language.current = lang;
            localStorage.setItem('pmcLanguage', lang);
            location.replace(location.pathname + '?lang=' + lang);
        },
        logout() {
            clearUser();
            if(window.location.pathname == '/'){
                this.$forceUpdate(); 
            } else {
                router.push({name: 'Discover'});
            }
        },
        toggleDropdown(value) {
            if(this.isMobileNav) return
            this.dropdownVisible = value
        },
        toggleSearch() {
            this.searchVisible = !this.searchVisible

            if(this.searchVisible) {
                this.$refs.searchInput.focus()
            }
        },
        clearSearch() {
            if(this.searchValue !== '') {
                this.searchValue = ''
                this.search()
            }
        },
        search() {
            this.$store.commit('setSearchTerm', this.searchValue)

            if(router.currentRoute.name !== 'Workouts') {
                router.push({ name: 'Workouts'})
            }
        },
        addEventListeners() {
            document.addEventListener('click', this.elementClickHandler)
        },
        removeEventListeners() {
            document.removeEventListener('click', this.elementClickHandler)
        },
        elementClickHandler(e) {
            const closestSearch = e.target.closest('.navigation__search')
            if(!closestSearch && this.searchValue === '') {
                this.searchVisible = false
            }
            const closestProfileNav = e.target.closest('.profile-nav')
            if(!closestProfileNav) {
                this.dropdownVisible = false
            }
        },
        toggleProfileNav(event) {
            if(this.isMobileNav) {
                event.preventDefault()
                this.dropdownVisible = !this.dropdownVisible
            }
        },
        filterClicked() {
            window.scrollTo(0,0);
        },
        outboundLinkClicked(url) {
            captureOutboundLink(url, {navigation: false, event: {type: "outbound", value: "web_shop_puma_ecom"}})
            return false
        },
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        }
    },
    watch:{
        $route (to, from){
            this.dropdownVisible = false

            if(to.name !== 'Workouts') {
                this.searchValue = ''
                this.$store.commit('setSearchTerm', this.searchValue)
            }
        }
    }
}
</script>

<style lang="scss">
@import "~sass-mq";

.navigation {
    $block: &;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: $puma-color-black;
    height: $nav-height-desktop;
    z-index: 999999999999;

    display: flex;
    align-items: center;

    &  > * {
        width: 33.3333%;
    }

    @include mq($until: tablet) {
        height: $nav-height-mobile;
    }

    & + .site-content {
        padding-top: $nav-height-desktop;

        @include mq($until: tablet) {
            padding-top: $nav-height-mobile;
        }
    }

     .language-switcher-mobile {
        width: 100%;
        position: absolute;
        top: 100%;
        left: 0;
        background-color: $puma-color-neutral-90;
        padding: 16px 20px 0 20px;

        &__text {
            padding-bottom: 18px;
            cursor: pointer;
            text-transform: uppercase;
            color: rgba($puma-color-neutral-10, 0.6);
            font-weight: 500;

            &.active {
                color: #ffffff;
            }

            span {
                text-transform: none;
                font-weight: 400;
            }
        }
    }

    &__logo {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        line-height: 1;
        /* margin-right: 80px; */

        @include mq($until: tablet) {
            justify-content: flex-start;
        }

        img {
            width: 102px;
            height: 35px;

            @include mq($until: tablet) {
                width: 73px;
                height: 25px;
            }
        }
    }

    &__main {
        display: flex;
        height: 100%;

        &__link {
            position: relative;
            color: $puma-color-neutral-10;
            font-weight: $font-weight-bold;
            text-transform: uppercase;
            font-size: $puma-size-font-sm;
            height: 100%;
            display: flex;
            align-items: center;
            margin-right: 60px;

            &:after {
                content: "";
                display: block;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 2px;
                background: $puma-color-neutral-10;
                opacity: 0;
            }

            &.router-link-active {
                &:after {
                    opacity: 1;
                }
            }
            
        }
    }

    &__pumacom {
        height: 100%;
        display: flex;
        align-items: center;
        font-weight: $font-weight-bold;
        color: $puma-color-neutral-10;
        height: 36px;
        border-radius: 18px;
        border: solid 1px rgba(white, 0.5);
        padding: 0 16px;

        &:hover {
            background: white;
            color: black;
        }

        @include mq($until: tablet) {
            height: 30px;
            font-size: $puma-size-font-xs;
        }

        @include mq($until: mobile-landscape) {
            display: none;
        }
    }

    &__back {
        margin-right: 20px;
        color: $puma-color-neutral-10;
        line-height: 1;
        cursor: pointer;

        @include mq($until: tablet) {
            display: none;
            // left: $page-padding-small;
        }

        .icon {
            @include mq($until: tablet) {
                height: 20px;
                width: 20px;
            }
        }
    }

    &__left {
        display: flex;
        align-items: center;
        @include mq($until: tablet) {
            display: none;
        }
    }

    &__right {
        position: relative;
        z-index: 3;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 100%;
        margin-left: auto;

        &__login,
        &__filter {
            @include mq($until: tablet) {
                margin-right: -10px;
                height: 30px;
                line-height: 30px !important;
                font-size: $puma-size-font-sm;
                padding: 0 10px 0 12px !important;

                .icon {
                    height: 20px;
                    margin-left: 4px !important;
                }
            }
        }
        &__filter {
            &.button{
                @include mq($until: tablet-landscape) {
                    display: none;
                }
            }
        }

        &__item {
            position: relative;
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0 16px;

            @include mq($until: tablet) {
                padding: 0 8px;
            }

            @include mq($until: mobile-landscape) {
                padding: 0 5px;
            }

            &__language {
                display: flex;
                @include mq($until: mobile-landscape) {
                    min-width: 50px;
                }
            }

            &:last-child {
                padding-right: 0;

                @include mq($until: mobile-landscape) {
                    margin-right: -8px;
                }
            }

            &.language-switcher {
                color: #ffffff;
                font-size: $puma-size-font-sm;
                font-weight: 700;
                position: relative;
                margin-right: 16px;

                .icon {
                    fill: none;
                    stroke: currentColor;
                    margin-top: 7px;

                    @include mq($until: mobile-landscape) {
                        margin-top: 5px;
                    }
                }

                &--hover {
                    background: $puma-color-neutral-90;
                }
            }

            &__body {
                transition: .25s all ease;
                position: absolute;
                top: 100%;
                width: 180px;
                background-color: $puma-color-neutral-90;
                left: 0;
                padding: 16px 16px 0 16px;
                display: flex;
                flex-direction: column;
                color: rgba($puma-color-neutral-10, .6);

                &__text {
                    padding-bottom: 18px;
                    cursor: pointer;
                    text-transform: uppercase;

                    &.active {
                        color: #ffffff;
                    }
                }
                span {
                    font-weight: 400;
                    padding-left: 10px;
                    text-transform: none;
                }
            }

            &__text {
                margin-right: 8px;
                text-transform: uppercase;
            }
        }

        &__link {
            position: relative;
            color: $puma-color-neutral-10;
            line-height: 1;
            display: block;
            cursor: pointer;

            @include mq($until: tablet) {
                .icon {
                    height: 20px;
                }
            }

            &--mobile {
                @include mq(tablet-landscape) {
                    display: none;
                }
            }


            &:after {
                content: '';
                display: block;
                width: 4px;
                height: 4px;
                background-color: $puma-color-neutral-10;
                position: absolute;
                top: 100%;
                left: 50%;
                transform: translate(-50%, 2px);
                border-radius: 100%;
                opacity: 0;
                transition: opacity 200ms $ease-out-quad;

                @include mq($until: tablet) {
                     transform: translate(-50%, 0);
                }
            }

            &.router-link-active {
                &:after {
                    opacity: 1;
                }
            }

            &.active {
                @include mq($until: tablet-landscape) {
                    &:after {
                        opacity: 1;
                    }  
                }
            }
        }
    }

    &__dropdown {
        position: absolute;
        left: 50%;
        top: 100%;
        transform: translateX(-50%);
        background: white;
        width: 250px;

        border: 1px solid rgba(black, 0.1);
        border-top: none;

        opacity: 0;
        margin-top: 10px;
        pointer-events: none;
        transition: all 300ms $ease-out-quad;

        &.visible {
            opacity: 1;
            margin-top: 0; 
            pointer-events: auto;
        }

        @include mq($until: tablet-landscape) {
            position: fixed;
            top: $nav-height-desktop;
            left: 0;
            width: 100%;
            transform: none;
            box-shadow: 0px 13px 15px -6px rgba(0,0,0,0.6);
        }

        @include mq($until: tablet) {
            top: $nav-height-mobile;
        }

        &__top {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 32px;
            border-bottom: 1px solid rgba(black, 0.1);

            @include mq($until: tablet-landscape) {
                padding: 40px;
            }
        }

        &__bottom {
            text-align: center;
            padding: 16px 20px;
            text-transform: uppercase;

            @include mq($until: tablet) {
                padding: 20px;
            }
        }

        &__link {
            cursor: pointer;

            &:not(:last-child) {
                margin-bottom: 16px;
            }
        }
    }

    &__search {
        position: relative;
        z-index: 3;

        &__input {
            position: absolute;
            z-index: 4;
            top: 50%;
            transform: translate(10px, -50%);
            right: 0;
            background: $puma-color-neutral-90;
            color: white;
            border: none;
            outline: none;
            height: 44px;
            width: 230px;
            border-radius: 2px;
            padding: 0 45px 0 20px;

            opacity: 0;
            pointer-events: none;
            margin-right: -10px;
            transition: all 300ms $ease-out-quad;

            &::-ms-clear,
            &::-ms-reveal {
                display: none; 
                width : 0; 
                height: 0;
            }
            &.visible {
                opacity: 1;
                pointer-events: auto;
                margin-right: 0;
            }

            @include mq($until: tablet-landscape) {
                position: fixed;
                top: $nav-height-desktop;
                left: 0;
                right: 0;
                transform: none;
                height: 60px;
                width: 100%;
                border-radius: 0;
            }

            @include mq($until: tablet) {
                top: $nav-height-mobile;
            }
        }

        &__icon {
            position: relative;
            z-index: 10;

            &.search {
                .filled & {
                    opacity: 0;

                    @include mq($until: tablet-landscape) {
                        opacity: 1;
                    }
                }
            }

            &.close {
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                pointer-events: none;

                .filled & {
                    opacity: 1;
                    pointer-events: auto;
                }

                @include mq($until: tablet-landscape) {
                    position: fixed;
                    top: $nav-height-desktop;
                    right: 20px;
                    left: auto;
                    margin-top: 19px;
                }

                @include mq($until: tablet) {
                    top: $nav-height-mobile;
                }
            }
        }
    }
}
</style>
